import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getPilotsList = async () => {
  const data = await fetchData(ENDPOINTS.GET.PILOT_LIST, {
    method: METHODS.GET,
  });
  return data;
};
